namespace GeniuzPOS.Inventory {
    export class IcStockAdjustOutColumns {
        static columnsKey = 'Inventory.IcStockAdjustOut';
    }
}
